module.exports = __webpack_public_path__ + "static/media/insta.c83bf1f2.svg";